import { render, staticRenderFns } from "./OrderItemLinkCreateForm.vue?vue&type=template&id=5714ab70"
import script from "./OrderItemLinkCreateForm.vue?vue&type=script&lang=js"
export * from "./OrderItemLinkCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports